export default {
  name: 'schema',
  signature: '[COMMAND]',
  isGroupRoot: true,
  description: 'Interacts with Sanity Studio schema configurations',
}
